export default __webpack_public_path__ + "static/media/xbox.63a50e86.svg";